import React, { useState } from "react";
import { LucideIcon, Briefcase, Calendar, Plane, Syringe, Clipboard } from "lucide-react";

interface IconDropdownProps {
  onSelect: (icon: string) => void;
}

const icons: { name: string; Icon: LucideIcon }[] = [
  { name: "briefcase", Icon: Briefcase },
  { name: "calendar", Icon: Calendar },
  { name: "plane", Icon: Plane },
  { name: "syringe", Icon: Syringe },
  { name: "clipboard", Icon: Clipboard },
];

const CategoryIconDropdown: React.FC<IconDropdownProps> = ({ onSelect }) => {
  const [selectedIcon, setSelectedIcon] = useState<string>(icons[0].name);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedIcon(event.target.value);
    onSelect(event.target.value);
  };

  // Find the selected icon once
  const SelectedIcon = icons.find((icon) => icon.name === selectedIcon)?.Icon;

  return (
    <div className="relative w-48">
      <div className="relative flex items-center border border-gray-300 rounded-md bg-white shadow-sm">
        <span className="p-2">
          {SelectedIcon && <SelectedIcon size={20} />}
        </span>
        <select
          value={selectedIcon}
          onChange={handleChange}
          className="w-full p-2 pl-10 bg-transparent appearance-none outline-none cursor-pointer"
        >
          {icons.map((icon) => (
            <option key={icon.name} value={icon.name}>
              {icon.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CategoryIconDropdown;
